import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Endpoints } from '../../api';
import { AppThunk, RootState } from '../store';
import { postData } from '../thunks/itemsApi';

export interface chatMessages {
    value: Array<any>;
    status: 'idle' | 'loading' | 'failed';
}

const initialState: chatMessages = {
    value: [],
    status: 'idle'
};

export const fetchMessages = createAsyncThunk('messages', async (data: any) => {
    const response = await postData(Endpoints.chatUrl + '/home/ChatByRoom', data);
    return response;
});

export const deleteMessage = createAsyncThunk(
    'messages/deleteMessage',
    async (payload: { userId: number; messageId: number }) => {
        const response = await postData(Endpoints.chatUrl + '/chat/DeleteMessage', {
            userId: Number(payload.userId),
            messageId: Number(payload.messageId)
        });
        return { ...payload, response };
    }
);

export const messageSlice = createSlice({
    name: 'messages',
    initialState,
    reducers: {
        setMessages: (state, action: PayloadAction<Array<any>>) => {
            state.value = action.payload;
        },
        clearMessages: (state) => {
            state.value = [];
        },
        updateMessages: (state, action: PayloadAction<any>) => {
            state.value.push(action.payload);
        },
        removeMessageById: (state, action: PayloadAction<number>) => {
            state.value = state.value.filter((m: any) => m.id !== action.payload);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMessages.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMessages.fulfilled, (state, action) => {
                state.status = 'idle';
                state.value = action.payload?.data ?? action.payload ?? [];
            })
            .addCase(deleteMessage.fulfilled, (state, action) => {
                state.value = state.value.filter((m: any) => m.id !== action.meta.arg.messageId);
            });
    }
});

export const { setMessages, clearMessages, updateMessages, removeMessageById } = messageSlice.actions;

export const selectMessages = (state: RootState) => state.chatMessages.value;

export default messageSlice.reducer;

export const fetchMessagesAsync =
    (data: any): AppThunk =>
    async (dispatch) => {
        try {
            dispatch(fetchMessages(data));
        } catch (err) {
            console.error(err);
        }
    };

export async function chatSendMessage(body: any) {
    const url = Endpoints.chatUrl + '/chat/' + body.senderId + '/message';
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
}
